// extracted by mini-css-extract-plugin
export var notificationHost = "_gj-0";